import messages from './messages';

export default { messages };
